import { useParams } from 'react-router-dom';
import { FormOverview } from '@/components/FormOverview/FormOverview';

export function FormOverviewScreen() {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;
  return <FormOverview key={id} formId={id} />;
}
